import timeGrid from 'src/router/middleware/timeGrid/timeGrid.js'
import auth from 'src/router/middleware/authentification/auth.js'

const Calendar = () => import('src/views/Channels/Calendar/Calendar.vue')
const EventDetailsView = () => import('src/views/Channels/Calendar/EventDetailsView.vue')
const CalendarList = () => import('src/components/calendar/list/CalendarList.vue')
const CalendarGrid = () => import('src/components/calendar/grid/CalendarGrid.vue')

export default [
  {
    path: '/calendar/:id',
    name: 'calendar',
    component: Calendar,
    children: [
      {
        path: 'list',
        component: CalendarList,
        name: 'calendar-list',
        meta: {
          middleware: [auth],
          headerText: 'calendar.title',
          noSchoolHeader: 'global.headers.weekly_schedule',
          group: 'calendar',
          layout: 'SduiWithScrollContainer',
          preventScrollTop: true,
          enableSwReload: true
        }
      },
      {
        path: 'grid',
        component: CalendarGrid,
        name: 'calendar-grid',
        meta: {
          middleware: [auth, timeGrid],
          headerText: 'calendar.title',
          noSchoolHeader: 'global.headers.weekly_schedule',
          group: 'calendar',
          layout: 'SduiWithScrollContainer',
          preventScrollTop: true,
          enableSwReload: true
        }
      }
    ]
  },
  {
    path: '/calendar/:calendar_id/event/:event_id',
    name: 'calendar-event-view',
    component: EventDetailsView,
    meta: {
      middleware: [auth],
      preventScrollTop: true,
      enableSwReload: true,
      headerText: 'global.headers.event_details'
    }
  }
]
